const { getCurrentTenant } = require('@vp/tenant-resolution');
const { getCurrentCulture } = require('@vp/culture-resolution');
const CookieUtil = require('./cookieUtil');
const UserAgent = require('./userAgent');
const CustomDomain = require('./customDomain');
const Gtm = require('./gtm');
const noTrackingWriteKey = 'oOgyr9bTme0dtCxg9IxbESBjTNQQjxca';

function load() {
    // Get config from script element data attribute "data-write-key"
    const scriptTag = document.getElementById('tracking-vp-dcp') || document.getElementById('tracking');
    const data = getDataAttributes(scriptTag);
    return applyOverride(
        data.writeKey,
        data.tenant,
        data.culture,
        undefined,
        undefined,
        data.suppressReloadOnConsentSubmit,
        undefined,
        undefined,
        false,
        undefined,
        undefined
    );
}

function applyOverride(
    writeKey,
    tenant,
    culture,
    sourceMiddlewares,
    destinationMiddlewares,
    suppressReloadOnConsentSubmit,
    onError,
    consentManagerCssClassNames,
    disableWebVitals,
    scriptNonce,
    featureFlags
) {
    const storeWriteKey = getOverrideWriteKey();

    if (storeWriteKey) {
        writeKey = storeWriteKey;
    }

    tenant = tenant || getCurrentTenant();
    culture = culture || getCurrentCulture();

    const customDomainConfig = CustomDomain.getConfig(writeKey);

    return {
        writeKey: writeKey,
        tenant: tenant,
        culture: culture,
        shouldTrack: !UserAgent.hasNoTrack(),
        domain: customDomainConfig.domain,
        useAnalyticsAlias: customDomainConfig.useAlias,
        apiHost: customDomainConfig.apiHost,
        sourceMiddlewares: sourceMiddlewares,
        destinationMiddlewares: destinationMiddlewares,
        suppressReloadOnConsentSubmit: suppressReloadOnConsentSubmit === true, // sanity check for correct data type
        onError: typeof onError === 'function' ? onError : defaultOnError,
        consentManagerCssClassNames,
        disableWebVitals,
        scriptNonce,
        featureFlags,
        pciCompliantGtmContainerId: Gtm.getPciCompliantGtmContainerOverride(tenant)
    };
}

function getOverrideWriteKey() {
    if (UserAgent.hasSiteTest()) {
        console.log('Tracking to testing source based on user agent');
        return noTrackingWriteKey;
    }

    const storeWriteKey = getStoreWriteKey();

    if (storeWriteKey) {
        console.log('Override write key has been detected in local storage');
        return storeWriteKey;
    }

    const cookieWriteKey = CookieUtil.getCookie('data-write-key');

    if (cookieWriteKey) {
        console.log('Override write key has been detected in cookie');
        return cookieWriteKey;
    }

    return undefined;
}

function getDataAttributes(scriptTag) {
    return {
        writeKey: getDataAttribute(scriptTag, 'write-key'),
        tenant: getDataAttribute(scriptTag, 'tenant'),
        culture: getDataAttribute(scriptTag, 'culture'),
        suppressReloadOnConsentSubmit: getDataAttribute(scriptTag, 'suppressReloadOnConsentSubmit') === 'true'
    };
}

function getDataAttribute(element, name) {
    return element.getAttribute(`data-${name}`);
}

function getStoreWriteKey() {
    try {
        return window.localStorage.getItem('data-write-key') || undefined;
    } catch (e) {
        // localStorage may be unavailable (e.g. disabled cookies, sandboxed iframe)
        return undefined;
    }
}

function defaultOnError(error) {
    console.error(JSON.stringify(error));
}

module.exports = {
    load: load,
    applyOverride: applyOverride,
    noTrackingWriteKey: noTrackingWriteKey
};
